import React, { useState } from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import styled from 'styled-components/macro';

const Input = styled(OutlinedInput)`
  && {
    // display: block;

    // This is used to get the actul text aligned with the rest of the document text
    width:${({ alignText }) => (alignText ? 'calc(100% + 14px);' : '100%;')}
  
    position: relative;
    ${({ alignText }) => alignText && 'left: -14px;'}
  }

  [class*='MuiOutlinedInput-notchedOutline'] {
    border-color: transparent;
    transition: border-color 0.2s linear;

    @media print {
      border-color: transparent !important;
    }
  }

  [class*='MuiOutlinedInput-input'] {
    font-weight: 600;
    font-size: 18px;
    padding: 10.5px 14px;
    width: calc(100% - 14px);
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${({ $customCSS }) => $customCSS}
`;

const EditableTitle = ({
  id,
  content,
  setContent,
  onBlur,
  alignText,
  inputProps,
  customCSS,
  ...props
}) => {
  // const [isEditable, setIsEditable] = useState(false);

  return (
    <Input
      alignText={alignText}
      value={content}
      onChange={e => setContent(e.target.value)}
      onBlur={onBlur}
      inputProps={{ 'data-testid': `editable-title-${id}`, ...inputProps }}
      $customCSS={customCSS}
      {...props}
    />
  );
};

export default EditableTitle;
